"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Integration_module_css_1 = __importDefault(require("../../Integration.module.css"));
var LiveResourceScriptAccordion = function (props) {
    var _a;
    var resourceEditorData = (_a = props.resourceEditorData) !== null && _a !== void 0 ? _a : {
        template: props.resourceScriptTemplate.identifier,
        name: props.resourceScriptTemplate.name,
        variables: {}
    };
    if (!resourceEditorData.variables) {
        resourceEditorData.variables = {};
    }
    var onScriptSettingsChangedHandler = function (event) {
        var propKey = event.target.dataset.key;
        // TODO: allow live scripts to have settings.
    };
    if (props.resourceScriptTemplate.settings.length < 1) {
        return (react_1.default.createElement("div", { style: { padding: "12px 16px", borderRadius: "4px", backgroundColor: "rgb(249, 248, 248)", boxShadow: "1px 1px 1px -1px rgba(0, 0, 0, 0.2), 1px 1px 1px 0px rgba(0, 0, 0, 0.1), 1px 1px 1px 0px rgba(0, 0, 0, 0.1)" } },
            react_1.default.createElement("div", { className: Integration_module_css_1.default["accordion-summary-container"] },
                react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
                    react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, props.resourceScriptTemplate.name)),
                react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } }))));
    }
    else {
        var primaryColumnSettings = props.resourceScriptTemplate.settings
            .filter(function (setting) {
            return setting.section !== "secondary" && setting.isVisible(resourceEditorData.variables);
        });
        var secondaryColumnSettings = props.resourceScriptTemplate.settings
            .filter(function (setting) {
            return setting.section === "secondary" && setting.isVisible(resourceEditorData.variables);
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(material_1.Accordion, { expanded: props.expanded, onChange: props.onChange, sx: {
                    borderRadius: "10px",
                    boxShadow: "\n                1px 1px 1px -1px rgba(0, 0, 0, 0.2),\n                1px 1px 1px 0px rgba(0, 0, 0, 0.1),\n                1px 1px 1px 0px rgba(0, 0, 0, 0.1)",
                    width: "100%",
                } },
                react_1.default.createElement(material_1.AccordionSummary, { "data-cy": "integrationResourceAccordionHeader", expandIcon: react_1.default.createElement(ExpandMore_1.default, null), sx: {
                        "&.Mui-expanded": {
                            backgroundColor: "var(--secondary-color)",
                            height: "48px",
                            minHeight: 0
                        },
                        backgroundColor: "#f9f8f8"
                    } },
                    react_1.default.createElement("div", { className: Integration_module_css_1.default["accordion-summary-container"] },
                        react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } },
                            react_1.default.createElement("div", { style: { color: "var(--info-color)" } }, props.resourceScriptTemplate.name)),
                        react_1.default.createElement("div", { style: { display: "flex", alignItems: "center" } }))),
                react_1.default.createElement(material_1.AccordionDetails, null,
                    react_1.default.createElement("div", { style: { display: "flex" } },
                        react_1.default.createElement("div", { style: { width: "50%" } }, primaryColumnSettings && primaryColumnSettings.map(function (setting) {
                            return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: resourceEditorData.variables[setting.key], disabled: setting.isDisabled(resourceEditorData.variables), setting: setting, onChange: onScriptSettingsChangedHandler }));
                        })),
                        react_1.default.createElement("div", { style: { width: "50%", marginLeft: "50px" } }, secondaryColumnSettings && secondaryColumnSettings.map(function (setting) {
                            var _a;
                            return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: (_a = resourceEditorData === null || resourceEditorData === void 0 ? void 0 : resourceEditorData.variables[setting.key]) !== null && _a !== void 0 ? _a : "", disabled: setting.isDisabled(resourceEditorData.variables), setting: setting, onChange: onScriptSettingsChangedHandler }));
                        })))))));
    }
};
exports.default = LiveResourceScriptAccordion;
